import { render } from "./accounts-locking-modal.vue?vue&type=template&id=fa4a4028&scoped=true"
import script from "./accounts-locking-modal.vue?vue&type=script&lang=js"
export * from "./accounts-locking-modal.vue?vue&type=script&lang=js"

import "./accounts-locking-modal.vue?vue&type=style&index=0&id=fa4a4028&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa4a4028"]])

export default __exports__